import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function BookingForm() {
  const [form, setForm] = useState({
    checkIn: "",
    checkOut: "",
    roomType: "",
    guests: "",
    kids: "",
    fullName: "",
    email: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("https://backend.ferejhotel.com/api/bookings", form);
      alert(res.data.message);
      setForm({
        checkIn: "",
        checkOut: "",
        roomType: "",
        guests: "",
        kids: "",
        fullName: "",
        email: "",
      });
    } catch (error) {
      alert("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-white flex flex-col">
      {/* Navbar */}
      <nav className="w-full bg-black text-white py-4 px-6 flex items-center justify-between shadow-lg sticky top-0 z-50">
        <Link
          to="/"
          className="flex items-center gap-2 hover:text-yellow-400 transition-all duration-300 font-semibold"
        >
          ← Back Home
        </Link>
        <div className="font-bold text-lg tracking-wider">Ferej Hotel Booking</div>
      </nav>

      {/* Form Container */}
      <div className="flex-grow flex items-center justify-center py-10 px-4">
        <form
          onSubmit={handleSubmit}
          className="bg-gradient-to-br from-yellow-300 to-yellow-100 shadow-2xl rounded-3xl w-full max-w-4xl p-10 space-y-6"
        >
          <h2 className="text-4xl font-extrabold text-center text-black mb-8">
            Room Booking
          </h2>

          {/* Check-In / Check-Out */}
          <div className="grid grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="text-gray-800 font-medium mb-2">Check-In</label>
              <input
                type="date"
                name="checkIn"
                value={form.checkIn}
                onChange={handleChange}
                className="bg-gradient-to-r from-yellow-200 to-yellow-50 border border-yellow-400 rounded-xl p-4 focus:ring-2 focus:ring-yellow-400 focus:outline-none text-lg"
                required
              />
            </div>
            <div className="flex flex-col">
              <label className="text-gray-800 font-medium mb-2">Check-Out</label>
              <input
                type="date"
                name="checkOut"
                value={form.checkOut}
                onChange={handleChange}
                className="bg-gradient-to-r from-yellow-200 to-yellow-50 border border-yellow-400 rounded-xl p-4 focus:ring-2 focus:ring-yellow-400 focus:outline-none text-lg"
                required
              />
            </div>
          </div>

          {/* Room Type */}
          <div className="flex flex-col">
            <label className="text-gray-800 font-medium mb-2">Room Type</label>
            <select
              name="roomType"
              value={form.roomType}
              onChange={handleChange}
              className="bg-gradient-to-r from-yellow-200 to-yellow-50 border border-yellow-400 rounded-xl p-4 focus:ring-2 focus:ring-yellow-400 focus:outline-none text-lg"
              required
            >
              <option value="">Select Room Type</option>
              <option value="Single">Single Room</option>
              <option value="Double">King size Room</option>
              <option value="Deluxe">Twin Room</option>
              <option value="Suite">Suit(vip) Room</option>
            </select>
          </div>

          {/* Guests / Kids */}
          <div className="grid grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="text-gray-800 font-medium mb-2">Guests</label>
              <input
                type="number"
                name="guests"
                value={form.guests}
                onChange={handleChange}
                placeholder="Number of Guests"
                className="bg-gradient-to-r from-yellow-200 to-yellow-50 border border-yellow-400 rounded-xl p-4 focus:ring-2 focus:ring-yellow-400 focus:outline-none text-lg"
                required
              />
            </div>
            <div className="flex flex-col">
              <label className="text-gray-800 font-medium mb-2">Kids?</label>
              <select
                name="kids"
                value={form.kids}
                onChange={handleChange}
                className="bg-gradient-to-r from-yellow-200 to-yellow-50 border border-yellow-400 rounded-xl p-4 focus:ring-2 focus:ring-yellow-400 focus:outline-none text-lg"
                required
              >
                <option value="">Select Option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

          {/* Full Name / Email */}
          <div className="grid grid-cols-2 gap-6">
            <div className="flex flex-col">
              <label className="text-gray-800 font-medium mb-2">Full Name</label>
              <input
                type="text"
                name="fullName"
                value={form.fullName}
                onChange={handleChange}
                placeholder="Full Name"
                className="bg-gradient-to-r from-yellow-200 to-yellow-50 border border-yellow-400 rounded-xl p-4 focus:ring-2 focus:ring-yellow-400 focus:outline-none text-lg"
                required
              />
            </div>
            <div className="flex flex-col">
              <label className="text-gray-800 font-medium mb-2">Email Address</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email Address"
                className="bg-gradient-to-r from-yellow-200 to-yellow-50 border border-yellow-400 rounded-xl p-4 focus:ring-2 focus:ring-yellow-400 focus:outline-none text-lg"
                required
              />
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-yellow-500 to-yellow-300 text-black font-bold py-4 rounded-2xl shadow-xl hover:shadow-yellow-400/50 hover:scale-105 transition-all duration-300 text-lg"
          >
            Submit Booking
          </button>
        </form>
      </div>
    </div>
  );
}
